import {Component, property} from '@wonderlandengine/api';

import {storageSpace13} from './globals.js';
import {State} from './classes/gameState.js';
import {WLUtils} from './utils/WLUtils.js';

export class ShowInState extends Component {
    static TypeName = 'show-in-state';

    @property.enum(Object.keys(State).filter((e) => isNaN(Number(e))))
    visibleState: State;

    start() {
        WLUtils.setActive(this.object, false);
        storageSpace13.gameState.changeOnProperty('isInVR').add(this.handleSwitchToVR);
        storageSpace13.gameState.changeOnProperty('state').add((state) => {
            if (state === this.visibleState) {
                if (storageSpace13.gameState.isInVR) {
                    this.moveIntoView();
                }
            }
            if (state !== this.visibleState) {
                this.moveOutOfView();
            }
        });
    }

    moveIntoView = () => {
        WLUtils.setActive(this.object, true);
    };

    moveOutOfView = () => {
        WLUtils.setActive(this.object, false);
    };

    handleSwitchToVR = (isInVR: boolean) => {
        if (isInVR === true) {
            if (storageSpace13.gameState.state == this.visibleState) {
                this.moveIntoView();
            }
        } else {
            this.moveOutOfView();
        }
    };
}
